export default "__VITE_ASSET__BvlsSRzY__"